import { render, staticRenderFns } from "./PaymentForTravelPacakage.vue?vue&type=template&id=fd552870&scoped=true"
import script from "./PaymentForTravelPacakage.vue?vue&type=script&lang=js"
export * from "./PaymentForTravelPacakage.vue?vue&type=script&lang=js"
import style0 from "./PaymentForTravelPacakage.vue?vue&type=style&index=0&id=fd552870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd552870",
  null
  
)

export default component.exports